// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ModalModuleCss from "./Modal.module.css";

var s = ModalModuleCss;

function Modal(Props) {
  var handleClose = Props.handleClose;
  var isOpen = Props.isOpen;
  var children = Props.children;
  var match = React.useState(function () {
        return false;
      });
  var setWasOpen = match[1];
  var wasOpen = match[0];
  React.useEffect((function () {
          if (!wasOpen && isOpen) {
            Curry._1(setWasOpen, (function (param) {
                    return true;
                  }));
          }
          
        }), [
        isOpen,
        wasOpen,
        setWasOpen
      ]);
  return React.createElement("div", {
              className: s.bg + " " + (
                wasOpen ? (
                    isOpen ? s.shown : s.hidden
                  ) : ""
              ),
              onClick: (function (param) {
                  return Curry._1(handleClose, undefined);
                })
            }, React.createElement("div", {
                  className: s.modal,
                  onClick: (function (e) {
                      e.stopPropagation();
                      
                    })
                }, children));
}

var make = Modal;

export {
  s ,
  make ,
  
}
/* s Not a pure module */
